window.snacks = (function () {
  'use strict';
  var snacks = {};
  snacks.showSnackbar = function (data) {
    if (!data) return;
    if (data['timeout'] === undefined) {
      data['timeout'] = 5000;
    }
    var snackbarContainer = document.querySelector('#demo-toast-example');
    if (!snackbarContainer) {
      console.warn('snacks: #demo-toast-example not found', data.message);
      return;
    }
    if (!snackbarContainer.MaterialSnackbar && window.componentHandler &&
        typeof window.componentHandler.upgradeElement === 'function') {
      try {
        window.componentHandler.upgradeElement(snackbarContainer);
      } catch (err) {
        console.warn('snacks: upgradeElement failed', err);
      }
    }
    if (!snackbarContainer.MaterialSnackbar ||
        typeof snackbarContainer.MaterialSnackbar.showSnackbar !== 'function') {
      console.warn('snacks: MaterialSnackbar unavailable', data.message);
      return;
    }
    snackbarContainer.MaterialSnackbar.showSnackbar(data);
  };
  return snacks;
})();
